import React, { useEffect } from "react";
import List from "@material-ui/core/List";
import SortByFilter from "./FilterType/SortByFilter";
import PriceFilter from "./FilterType/PriceFilter";
import {useDispatch, useSelector} from "react-redux";
import GenericFilter from "./FilterType/GenericFilter";
import FilterListIcon from "@material-ui/icons/FilterList";
import CategoriesFilter from "./FilterType/CategoriesFilter";
import AvailableProductsFilter from "./FilterType/AvailableProductsFilter";
import NutritionFactFilter from "./FilterType/NutritionFactFilter";
import { fetchFilters } from "../../../store/actions/productFilter";

const ProductFilterList = ({
  filtersToApply,
  setFiltersToApply,
  setSortOption,
  sortOption,
  priceRangeToApply,
  setPriceRangeToApply,
  categoriesToApply,
  setCategoriesToApply,
  handleClearFilters,
  availableProducts,
  setAvailableProducts,
  nutritionalFact,
  setNutritionalFact,
}) => {
  //REDUX
    const dispatch = useDispatch()
  const filters = useSelector(
    (state) => state.productFilter?.storeFilters || []
  );
  const themeColor = useSelector((state) => state.store.store.settings?.dark);
  const settings = useSelector((state) => state.store.store.settings);
  const language = useSelector((state) => state.store.language);
  const nutritionalFactMaxMin = useSelector(
    (state) => state.productFilter?.allProductNutritionFact || {}
  );

  const checkIfNutritionalFactIsZero = () => {
    return !Object.values(nutritionalFactMaxMin).every(
      (value) => value[0] === 0 && value[1] === 0
    );
  };

  return (
    <List component="nav" aria-labelledby="nested-list-subheader">
      {settings.enable_sort_by_filter && (
        <SortByFilter sortOption={sortOption} setSortOption={setSortOption} />
      )}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "42px 12px 0 12px",
          flexDirection: language === "arabic" ? "row-reverse" : "row",
        }}
      >
        <span
          style={{
            fontWeight: "bold",
          }}
        >
          {language === "arabic" ? "التصفية" : "Filters"}
        </span>
        <div
          style={{
            display: "flex",
            flexDirection: language === "arabic" ? "row-reverse" : "row",
          }}
        >
          <span
            style={{
              fontWeight: "bold",
              color: themeColor,
              marginRight: language === "arabic" ? 0 : 18,
              marginLeft: language === "arabic" ? 18 : 0,
            }}
            onClick={handleClearFilters}
          >
            {language === "arabic" ? "امسح" : "clear"}
          </span>
          <FilterListIcon />
        </div>
      </div>
      <div
        style={{
          backgroundColor: "#FFFFFF",
          border: "2px solid #DEE2E6",
          paddingBottom: "12px",
        }}
      >
        <CategoriesFilter
          categoriesToApply={categoriesToApply}
          setCategoriesToApply={setCategoriesToApply}
        />
        {filters
          .filter((filter) => filter.options.length !== 0)
          .map((filter) => (
            <GenericFilter
              id={filter.id}
              key={filter.name}
              name={filter.name}
              type={filter.type}
              options={filter.options}
              ar_name={filter.ar_name}
              setFiltersToApply={setFiltersToApply}
              filtersToApply={filtersToApply}
            />
          ))}
        {settings.enable_price_filter && (
          <PriceFilter
            priceRangeToApply={priceRangeToApply}
            setPriceRangeToApply={setPriceRangeToApply}
          />
        )}
        {settings.show_nutrition_facts &&
          settings.enable_nutrition_fact_filter &&
          checkIfNutritionalFactIsZero() && (
            <NutritionFactFilter
              nutritionalFact={nutritionalFact}
              setNutritionalFact={setNutritionalFact}
            />
          )}
        {settings.enable_available_products_filter && (
          <AvailableProductsFilter
            availableProducts={availableProducts}
            setAvailableProducts={setAvailableProducts}
          />
        )}
      </div>
    </List>
  );
};

export default ProductFilterList;
